var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dropdown',{attrs:{"triggers":['hover'],"aria-role":"list","position":"is-bottom-left"},scopedSlots:_vm._u([{key:"trigger",fn:function(){return [_c('b-button',{attrs:{"slot":"trigger","type":{
        'is-white': _vm.t.details.status === 'open',
        'is-success': _vm.t.details.status === 'success',
        'is-smart-orange-7': _vm.t.details.status === 'refused',
        'is-light': _vm.t.details.status === 'cancelled',
        'is-warning': _vm.t.details.status === 'error',
        'is-dark': _vm.t.details.status === 'refunded',
        'is-danger': _vm.t.details.status === 'chargeback',
        'is-sea': _vm.t.details.status === 'pending',
        'is-light-green':
          _vm.t.details.status === 'billingPending' ||
          _vm.t.details.status === 'chargebackPaid'
      },"disabled":_vm.t.details.status === 'cancelled'},slot:"trigger"},[_vm._v("\n      "+_vm._s(_vm.t.details.status === "success"
          ? _vm.$t("transactions.statusSuccess")
          : _vm.t.details.status === "refused"
          ? _vm.$t("transactions.statusRefused")
          : _vm.t.details.status === "error"
          ? _vm.$t("transactions.statusError")
          : _vm.t.details.status === "cancelled"
          ? _vm.$t("transactions.statusCancelled")
          : _vm.t.details.status === "open"
          ? _vm.$t("transactions.statusOpen")
          : _vm.t.details.status === "pending"
          ? _vm.$t("transactions.statusPending")
          : _vm.t.details.status === "refundedRequested"
          ? _vm.$t("transactions.statusRefundRequested")
          : _vm.t.details.status === "refunded"
          ? _vm.$t("transactions.statusRefunded")
          : _vm.t.details.status === "refundRefused"
          ? _vm.$t("transactions.statusRefundRefused")
          : _vm.t.details.status === "refundFailed"
          ? _vm.$t("transactions.statusRefundFailed")
          : _vm.t.details.status === "refundReversed"
          ? _vm.$t("transactions.statusRefundReversed")
          : _vm.t.details.status === "chargeback"
          ? _vm.$t("transactions.statusChargeback")
          : _vm.t.details.status === "chargebackPaid"
          ? _vm.$t("transactions.statusChargebackPaid")
          : "-")+"\n    ")])]},proxy:true}])},[(_vm.t.details.status !== 'cancelled')?_c('div',[_c('b-dropdown-item',{attrs:{"aria-role":"listitem"}},[_c('p',[_vm._v(_vm._s(_vm.paymentMethods))])]),(['refused', 'error'].includes(_vm.t.details.status))?_c('b-dropdown-item',{attrs:{"aria-role":"listitem"}},[_c('b',[_vm._v(_vm._s(_vm.$t("transactions.response"))+": ")]),_vm._v("\n      "+_vm._s(_vm.t.tefTerminal.response.message)+"\n    ")]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }